import React, { useState, useEffect, useRef} from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";

const SearchableVendorSelect = ({
    value,
    onChange,
    vendorOptions
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const filteredVendors = vendorOptions.filter((v) =>
        (v.nameofcompany || "")
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    const selectedVendor = vendorOptions.find(
        (v) => String(v.id) === String(value)
    );

    return (
        <div
            className="searchable-invoice"
            ref={dropdownRef}
        >
            <button
                type="button"
                className="searchable-invoice-button"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>
                    {selectedVendor
                        ? selectedVendor.nameofcompany
                        : "Select Vendor"}
                </span>

                <span>▼</span>
            </button>

            {isOpen && (
                <div className="searchable-invoice-dropdown">

                    <input
                        type="text"
                        placeholder="Search vendor..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        autoFocus
                        className="searchable-invoice-search"
                    />

                    <div className="searchable-invoice-list">

                        <div
                            className="searchable-invoice-option"
                            onClick={() => {
                                onChange("");
                                setIsOpen(false);
                                setSearch("");
                            }}
                        >
                            Select Vendor
                        </div>

                        {filteredVendors.length > 0 ? (
                            filteredVendors.map((v, index) => (
                                <div
                                    key={`${v.id}-${index}`}
                                    className="searchable-invoice-option"
                                    onClick={() => {
                                        onChange(String(v.id));
                                        setIsOpen(false);
                                        setSearch("");
                                    }}
                                >
                                    {v.nameofcompany}
                                </div>
                            ))
                        ) : (
                            <div className="searchable-invoice-no-results">
                                No vendor found
                            </div>
                        )}

                    </div>
                </div>
            )}
        </div>
    );
};
const VendorAgreement = () => {
    const [vendorOptions, setVendorOptions] = useState([]);
    const [agreements, setAgreements] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [editId, setEditId] = useState(null);
    const [errors, setErrors] = useState({});
    const recordsPerPage = 10;
    const [showModal, setShowModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const [form, setForm] = useState({
        vendorId: "",
        agreementDate: "", 
        agreementStartDate: "",
        agreementEndDate: "",
        agreementAmount: "",
        agreementType: "",
        isActive: true,
        agreementFile: null
    });

    const handleFileOpen = (item) => {
        setSelectedFile(item);
        setShowModal(true);
    };

    const handleDownload = () => {
        if (selectedFile?.filePath) {
            const link = document.createElement("a");
            link.href = `/${selectedFile.filePath}`;
            link.download = selectedFile.fileName;
            link.click();
        }
    };

    useEffect(() => {
        loadVendors();
        loadAgreements();
    }, []);

    const loadVendors = async () => {
        try {
            const res = await axios.get("/api/UpdateData/GetVendorsList");
            setVendorOptions(res.data);
        } catch (err) {
            console.error("Error loading vendors:", err);
        }
    };

    const loadAgreements = async () => {
        try {
            const res = await axios.get("/api/vendoragreement");
            setAgreements(res.data);
        } catch (err) {
            console.error("Error loading agreements:", err);
        }
    };

    const validate = () => {
        const newErrors = {};
        if (!form.vendorId) newErrors.vendorId = "Vendor is required";
        if (!form.agreementType) newErrors.agreementType = "Agreement Type is required";
        if (form.agreementType !== "Approval" && !form.agreementDate)
            newErrors.agreementDate = "Agreement Date is required";
        if (form.agreementType !== "Opened Agreement" && form.agreementType !== "Approval" && !form.agreementStartDate)
            newErrors.agreementStartDate = "Start Date is required";
        if (form.agreementType !== "Opened Agreement" && form.agreementType !== "Approval" && !form.agreementEndDate)
            newErrors.agreementEndDate = "End Date is required";
        if (form.agreementStartDate && form.agreementEndDate &&
            new Date(form.agreementEndDate) < new Date(form.agreementStartDate)) {
            newErrors.agreementEndDate = "End Date must be after Start Date";
        }
        if (form.agreementType !== "Approval") {
            if (!form.agreementAmount) newErrors.agreementAmount = "Amount is required";
            if (Number(form.agreementAmount) <= 0) newErrors.agreementAmount = "Amount must be greater than zero";
        }
        if (form.agreementType !== "Approval" && !form.agreementFile && !editId) {
            alert("Please attach the agreement file.");
            return;
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validate()) return;

        try {
            const formData = new FormData();

            formData.append("vendorId", form.vendorId);
            formData.append("AgreementDate", form.agreementDate);
            formData.append("agreementStartDate", form.agreementStartDate);
            formData.append("agreementEndDate", form.agreementEndDate);
            formData.append("agreementAmount", form.agreementAmount || "0");
            formData.append("agreementType", form.agreementType);
            formData.append("isActive", form.isActive);

            // IMPORTANT: only append if file selected
            if (form.agreementFile) {
                formData.append("agreementFile", form.agreementFile);
            }

            if (editId) {
                await axios.put(
                    `/api/vendoragreement/${editId}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                alert("Agreement updated successfully");
            } else {
                await axios.post(
                    "/api/vendoragreement",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                alert("Agreement saved successfully");
            }

            resetForm();
            loadAgreements();
            setEditId(null);

        } catch (err) {
            console.error(err);
            alert("Error saving agreement");
        }
    };

    const resetForm = () => {
        setForm({
            vendorId: "",
            agreementDate: "",
            agreementStartDate: "",
            agreementEndDate: "",
            agreementAmount: "",
            agreementType: "",
            isActive: true,
            agreementFile: null
        });

        setEditId(null);
        setErrors({});
    };

    const handleEdit = (item) => {
        setEditId(item.agreementId);
        setForm({
            vendorId: item.vendorId,
            agreementDate: item.agreementDate, 
            agreementStartDate: item.agreementStartDate,
            agreementEndDate: item.agreementEndDate,
            agreementAmount: item.agreementAmount,
            agreementType: item.agreementType,
            isActive: item.isActive,
            agreementFile:item.agreementFile
        });
        window.scrollTo(0, 0);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this agreement?")) return;
        try {
            await axios.delete(`/api/vendoragreement/${id}`);
            alert("Agreement deleted successfully");
            loadAgreements();
        } catch (err) {
            alert("Error deleting agreement");
        }
    };

    const handleCancel = () => {
        setForm({ vendorId: "", agreementDate: "", agreementStartDate: "", agreementEndDate: "", agreementAmount: "", agreementType: "", isActive: true, agreementFile: null })
        setEditId(null);
        setErrors({});
    };

    const filteredAgreements = agreements.filter((item) => {
        const search = searchTerm.toLowerCase();

        return (
            item.vendorName?.toLowerCase().includes(search) ||
            item.agreementType?.toLowerCase().includes(search) ||
            item.agreementDate?.toLowerCase().includes(search) ||
            item.agreementStartDate?.toLowerCase().includes(search) ||
            item.agreementEndDate?.toLowerCase().includes(search) ||
            String(item.agreementAmount || "").toLowerCase().includes(search) ||
            (item.isActive ? "active" : "inactive").includes(search) ||
            item.fileName?.toLowerCase().includes(search)
        );
    });

    const indexOfLast = currentPage * recordsPerPage;
    const indexOfFirst = indexOfLast - recordsPerPage;

    const currentRecords = filteredAgreements.slice(
        indexOfFirst,
        indexOfLast
    );

    const totalPages = Math.ceil(
        filteredAgreements.length / recordsPerPage
    );
    return (
        <DashboardLayout>
            <div className="container-fluid py-3">

                {/* Form */}
                <div className="card shadow-sm border-0 mb-3">
                    <div className="card-header bg-primary text-white">
                        <h5 className="mb-0">{editId ? "Edit" : "Add"} Vendor Agreement</h5>
                    </div>
                    <div className="card-body py-3">
                        <div className="row g-3">

                            <div className="col-md-3">
                                <label className="form-label">Vendor Name <span className="text-danger">*</span></label>
                                <SearchableVendorSelect
                                    value={form.vendorId}
                                    onChange={(value) =>
                                        setForm({
                                            ...form,
                                            vendorId: value
                                        })
                                    }
                                    vendorOptions={vendorOptions}
                                />
                                {errors.vendorId && <div className="invalid-feedback">{errors.vendorId}</div>}
                            </div>
                            <div className="col-md-2">
                                <label className="form-label">Agreement Type <span className="text-danger">*</span></label>
                                <select
                                    className={`form-select ${errors.agreementType ? "is-invalid" : ""}`}
                                    value={form.agreementType}
                                    onChange={(e) => setForm({ ...form, agreementType: e.target.value })}
                                >
                                    <option value="">Select Type</option>
                                    <option value="Within Limit">Within Limit</option>
                                    <option value="Opened Agreement">Opened Agreement</option>
                                    <option value="Approval">Approval</option>
                                </select>
                                {errors.agreementType && <div className="invalid-feedback">{errors.agreementType}</div>}
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">
                                    Agreement Date {form.agreementType !== "Approval" && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type="date"
                                    className={`form-control ${errors.agreementDate ? "is-invalid" : ""}`}
                                    value={form.agreementDate}
                                    onChange={(e) => setForm({ ...form, agreementDate: e.target.value })}
                                />
                                {errors.agreementDate && <div className="invalid-feedback">{errors.agreementDate}</div>}
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">
                                    Start Date {form.agreementType !== "Opened Agreement" && form.agreementType !== "Approval" && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type="date"
                                    className={`form-control ${errors.agreementStartDate ? "is-invalid" : ""}`}
                                    value={form.agreementStartDate}
                                    onChange={(e) => setForm({ ...form, agreementStartDate: e.target.value })}
                                />
                                {errors.agreementStartDate && <div className="invalid-feedback">{errors.agreementStartDate}</div>}
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">
                                    End Date {form.agreementType !== "Opened Agreement" && form.agreementType !== "Approval" && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type="date"
                                    className={`form-control ${errors.agreementEndDate ? "is-invalid" : ""}`}
                                    value={form.agreementEndDate}
                                    onChange={(e) => setForm({ ...form, agreementEndDate: e.target.value })}
                                />
                                {errors.agreementEndDate && <div className="invalid-feedback">{errors.agreementEndDate}</div>}
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">Amount {form.agreementType !== "Approval" && <span className="text-danger">*</span>}</label>
                                <input
                                    type="number"
                                    className={`form-control ${errors.agreementAmount ? "is-invalid" : ""}`}
                                    value={form.agreementAmount}
                                    onChange={(e) => setForm({ ...form, agreementAmount: e.target.value })}
                                />
                                {errors.agreementAmount && <div className="invalid-feedback">{errors.agreementAmount}</div>}
                            </div>

                            <div className="col-md-1 d-flex align-items-center">
                                <div className="form-check mt-4">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={form.isActive}
                                        onChange={(e) => setForm({ ...form, isActive: e.target.checked })}
                                    />
                                    <label className="form-check-label">Active</label>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <label className="form-label">
                                    Agreement File {form.agreementType !== "Approval" && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            agreementFile: e.target.files[0]
                                        })
                                    }
                                    required
                                />
                            </div>

                            <div className="col-md-2 d-flex align-items-end gap-2">
                                <button className="btn btn-primary w-100" onClick={handleSave}>
                                    {editId ? "Update" : "Save"}
                                </button>
                                {editId && (
                                    <button className="btn btn-secondary w-100" onClick={handleCancel}>
                                        Cancel
                                    </button>
                                )}
                            </div>

                        </div>
                    </div>
                </div>

                {/* Table */}
                {/* Search */}
                <div className="p-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="🔍 Search By Vendors"
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                        style={{ width: "300px" }}
                    />
                </div>
                <div className="card shadow-sm border-0">
                    <div className="card-header bg-primary text-white d-flex justify-content-between">
                        <h5 className="mb-0">Agreement List</h5>
                        <span className="badge bg-light text-dark">
                            Total: {filteredAgreements.length}
                        </span>

                    </div>
                    <div className="table-responsive">
                        <table className="table table-hover table-striped mb-0">
                            <thead className="table-primary" style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                <tr>
                                    <th>#</th>
                                    <th>Vendor</th>
                                    <th>Agreement Date</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>File</th>
                                    <th colSpan="2" className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRecords.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: "center", padding: "20px", color: "#999" }}>
                                            No agreements found
                                        </td>
                                    </tr>
                                ) : (
                                    currentRecords.map((item, index) => (
                                        <tr key={item.agreementId}>
                                            <td>{indexOfFirst + index + 1}</td>
                                            <td>{item.vendorName}</td>
                                            <td>{item.agreementDate}</td>
                                            <td>{item.agreementStartDate}</td>
                                            <td>{item.agreementEndDate}</td>
                                            <td>₹ {Number(item.agreementAmount).toLocaleString()}</td>
                                            <td>
                                                <span className={`badge ${item.isActive ? "bg-success" : "bg-danger"}`}>
                                                    {item.isActive ? "Active" : "Inactive"}
                                                </span>
                                            </td>
                                            <td>
                                                {item.fileName ? (
                                                    <a
                                                        href={`/${item.filePath}`}
                                                        download={item.fileName}
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "blue",
                                                            textDecoration: "underline"
                                                        }}
                                                    >
                                                        📄 {item.fileName}
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-warning"
                                                    style={{ padding: "2px 6px", minWidth: "30px" }}
                                                    title="Edit"
                                                    onClick={() => handleEdit(item)}
                                                >
                                                    📝
                                                </button>
                                            </td>

                                            <td>
                                                <button
                                                    className="btn btn-sm"
                                                    style={{
                                                        padding: "2px 6px",
                                                        minWidth: "30px",
                                                        color: "red",
                                                        border: "1px solid red",
                                                        backgroundColor: "white"
                                                    }}
                                                    title="Delete"
                                                    onClick={() => handleDelete(item.agreementId)}
                                                >
                                                    🗑️
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>                     
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="card-footer">
                            <nav>
                                <ul className="pagination justify-content-end mb-0">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    )}
                </div>
            </div>
        </DashboardLayout>
    );
};

export default VendorAgreement;